module.exports = __webpack_public_path__ + "img/Oracles_wc.8cefd6cc.svg";